module.exports = __webpack_public_path__ + "static/cc_inputs-704119062df5977052e61ce62be7d746.png";